import {reactive} from "vue";

class UserConfirmationManager {
    constructor() {
        this.state = reactive({
            isVisible: false,
            message: 'You have already joined this workspace. Please wait while we confirm disconnection of your other session (this may take up to 30 seconds)'
        });
    }

    onDuplicateUserJoined(userName) {
        this.state.isVisible = true;
        this.state.userName = userName;
    }

    askConfirmationOnRejoin(connectionId, duplicateConnectionId) {
        const rejoin = (shouldRejoin) => {
            wv.sendTextMessage(text_removeDuplicateUserConfirmation + text_seperator + "0" + ":" + (shouldRejoin ? "1" : "0") + ":" + connectionId + ":" + duplicateConnectionId);
            if (shouldRejoin) {
                wv.redirectAfterEndMeeting();
            }
        };

        wv.promptWindow3dObject.changeText("Another device is trying to join this workspace. Do you want to switch to that device?", "Switch device", "Cancel");
        wv.promptWindow3dObject.askNow(rejoin);
    }

    async onRejoin() {
        this.state.message = "Device switched";
        await sleep(2000);
        const loginInfo = getDefaultLoginInfo();
        requestRegistration(loginInfo.id, this.state.userName, loginInfo.email);
        this.state.isVisible = false;
    }

    async onRejoinDenied() {
        this.state.isVisible = true;
        this.state.message = "Rejoining request is denied";
        await sleep(2000);
        this.state.isVisible = false;
        wv.redirectAfterEndMeeting();
    }

    onTrainingEnd() {
        if (!wv.effectController.trainingMeeting) {
            return;
        }

        if (this.state.isVisible) {
            return;
        }

        this.state.isVisible = true;
        this.state.message = "This experience has ended. No action is required. You may close this page or refresh to start over.";
    }

    isConfirmationMessageShown() {
        return this.state.isVisible;
    }

}

export const userConfirmationManager = new UserConfirmationManager();